import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import AuthModule from "./modules/auth";
import UserModule from "./modules/user";
import AdminModule from "./modules/admin";
import OrderHistoryModule from "./modules/orderHistory";
import ItemModule from "./modules/item";
import QuoteModule from "./modules/quote";
import CartModule from "./modules/cart";
import RouterModule from "./modules/router";
import OrderInformationModule from "@/store/modules/orderInformation";
import { makeid } from "@/common/utils";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

function vuexPersistPatch() {
  return (store) => {
    store._vm.$root.$data["vue-persist-patch-delay"] = true;

    store.subscribe((mutation) => {
      if (mutation.type === "RESTORE_MUTATION") {
        store._vm.$root.$data["vue-persist-patch-delay"] = false;
        store._vm.$root.$emit("storageReady");
      }
    });
  };
}

// const vuexLocal = new VuexPersistence({
//   storage: localStorage,
//   modules: ["Auth", "User", "Customer", "OrderHistory", "Item", "Quote"], //only save user module
// });

const vuexLocal = new VuexPersistence({
  storage: sessionStorage,
  restoreState: (key, storage) => {
    const state = storage.getItem("vuex");
    const data = JSON.parse(state);

    if (data && data.Cart) {
      data.Cart.accountCodeCarts = data.Cart.accountCodeCarts && data.Cart.accountCodeCarts['cart_' + data.Auth.customer_user.account_code].map((item) => {
        item.uuid = makeid();
        return item;
      });
    }
    return data;
    // console.log(key, storage.getItem('vuex'));
  },
  // modules: ['Cart'], //only save user module
});

const store = new Vuex.Store({
  modules: {
    Auth: AuthModule,
    User: UserModule,
    OrderHistory: OrderHistoryModule,
    Item: ItemModule,
    Quote: QuoteModule,
    Cart: CartModule,
    OrderInformation: OrderInformationModule,
    Admin: AdminModule,
    Router: RouterModule,
  },
  mutations: {
    RESTORE_MUTATION: vuexLocal.RESTORE_MUTATION,
  },
  plugins: [vuexLocal.plugin, vuexPersistPatch()],
  strict: debug,
});

export default store;
